var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0835 9.58331V12.4166C1.0835 17.1111 4.88908 20.9166 9.5835 20.9166H12.4168C17.1113 20.9166 20.9168 17.1111 20.9168 12.4166V9.58331C20.9168 4.88889 17.1113 1.08331 12.4168 1.08331H9.5835C4.88908 1.08331 1.0835 4.88889 1.0835 9.58331Z",
    stroke: "#4E5978",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11V16.6667",
    stroke: "#4E5978",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 7.45829C10.6098 7.45829 10.292 7.14054 10.292 6.74996C10.292 6.35938 10.6098 6.04163 11.0003 6.04163C11.3909 6.04163 11.7087 6.35938 11.7087 6.74996C11.7087 7.14054 11.3909 7.45829 11.0003 7.45829Z",
    fill: "#4E5978"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 5.33331C11.7826 5.33331 12.4168 5.96758 12.4168 6.74998C12.4168 7.53238 11.7826 8.16665 11.0002 8.16665C10.2178 8.16665 9.5835 7.53238 9.5835 6.74998C9.5835 5.96758 10.2178 5.33331 11.0002 5.33331Z",
    fill: "#4E5978"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.baa1213cb67b4f2bf6b90d8faeae3061.svg";
export { ForwardRef as ReactComponent };